import { useTheme } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { Moon, Sun } from 'lucide-react';
import styles from './Shell.module.css';

export const ThemeToggle = () => {
  const { t } = useTranslation();
  const { resolved, setMode } = useTheme();
  const next = resolved === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      className={styles['iconButton']}
      aria-label={t('shell.toggleTheme', { theme: t(`shell.theme_${next}`) })}
      onClick={() => {
        setMode(next);
      }}
    >
      {resolved === 'dark' ? <Moon size={20} aria-hidden="true" /> : <Sun size={20} aria-hidden="true" />}
    </button>
  );
};
